module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan3-1-c8ba96761bd06c6444efda188019c32a.webp";